var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"demo__Header--logo demo__pointer",attrs:{"src":_vm.$root.logoImg},on:{"click":_vm.logoClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }